export const providerColumns = {
  NAME: 'name',
  STATUS: 'status',
  ACTIONS: 'actions',
  SHARED_SERVICES: 'sharedServices',
  PACKING_SLIP_SHARING: 'packingSlipSharing',
};
